import { createFileRoute } from '@tanstack/react-router'
import { AlertsManagement } from '../../../../features/admin/AlertsManagement'

/* ───── Route Definition ───── */

export const Route = createFileRoute(
  '/_authenticated/admin/monitoring/alerts',
)({
  component: AdminMonitoringAlertsRoute,
})

/* ───── Route Component ───── */

function AdminMonitoringAlertsRoute() {
  return <AlertsManagement />
}
